import TEAM from "@/resources/content/team.json";
import { Member } from "../models/app-interfaces";

export const getLeadershipMembers = () => {
  const members = [
    "Henri Lichenstein",
    "Tian Xu",
    "Neil Solomons",
    "Tony Xu",
	"Julie Clifford",
    "Danyang Liu",
    "Jonathan Wang",
    "Jieqing Fan",
    "Leong Goh",
	"Robert Zhao",
	"Sicong Geng"
  ];

  return filterTeam(members);
};

export const getBoardMembers = () => {
  const members = [
    "Henri Lichenstein",
    "Tian Xu",
    "Cong Tony Xu",
    "Ya Chao (Rachel) Zhao",
    "Jian Li"
  ];

  return filterTeam(members);
};

export const getSabMembers = () => {
  const members = [
    "Zhijian James Chen",
	"Yue Zhang",
    "Lishan Su",
    "Juan Carlos",
    "Keith Fandrick"
  ];

  return filterTeam(members);
};

export const getPreviousMember = (member: Member) => {
  return getNewMember({ member, direction: "left" });
};

export const getNextMember = (member: Member) => {
  return getNewMember({ member, direction: "right" });
};

function getNewMember({
  member,
  direction
}: {
  member: Member;
  direction: "left" | "right";
}) {
  const memberIndex = TEAM.findIndex(
    (teamMember: Member) => teamMember.imageAlt === member.imageAlt
  );
  const teamTotal = TEAM.length;

  switch (direction) {
    case "left":
      return memberIndex > 0 ? TEAM[memberIndex - 1] : TEAM[teamTotal - 1];
    case "right":
      return memberIndex < teamTotal - 1 ? TEAM[memberIndex + 1] : TEAM[0];
    default:
      return member;
  }
}

function filterTeam(members: string[]) {
  return TEAM.filter((member: Member) => members.includes(member.imageAlt));
}
